/* ==========================================================================
   Global Distributors & System Integrators Interactive Zoomable Map Page
   Features 9-Items Per Page Pagination, Leaflet.js Pan/Zoom Engine,
   Card Spacing & Overflow Bug Fixes, Explicit Type Filters, and Full i18n.
   ========================================================================== */

import { t, getLocale } from '../locales/i18n.js';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

export function renderDistributorsMapPage(onNavigate) {
  const container = document.createElement('div');
  container.className = 'sed-page';

  // COMPLETE VERIFIED REAL DATASET (11 Distributors + 90 System Integrators & Technology Partners = 101 total)
  const allPartnersList = [
    {
        "id": 1,
        "name": "VARNET a.s.",
        "category": "distributor",
        "country": "CZ",
        "region": "cz",
        "city": "Třebíč, Czech Republic",
        "address": "U Obůrky 823/5, 674 01 Třebíč",
        "contact": "Alexandr Haman",
        "phone": "+420 568 834 834",
        "email": "a.haman@varnet.cz",
        "website": "www.varnet.cz",
        "lat": 49.2144,
        "lng": 15.8817,
        "cert": "Official SED Master Distributor"
    },
    {
        "id": 2,
        "name": "ADI Global Distribution (Resideo)",
        "category": "distributor",
        "country": "CZ",
        "region": "cz",
        "city": "Brno & Prague, Czech Republic",
        "address": "Havránkova 33, 619 00 Brno",
        "contact": "Jan Tomášek",
        "phone": "+420 603 554 650",
        "email": "jan.tomasek@adiglobal.com",
        "website": "www.adiglobal.com",
        "lat": 49.1672,
        "lng": 16.6145,
        "cert": "Global Security & Low-Voltage Distributor"
    },
    {
        "id": 3,
        "name": "ALARM ABSOLON, spol. s r.o.",
        "category": "distributor",
        "country": "CZ",
        "region": "cz",
        "city": "Prague, Czech Republic",
        "address": "Březinova 9/487, 186 00 Praha 8 - Karlín",
        "contact": "Sales Department",
        "phone": "+420 222 310 250",
        "email": "info@absolon.cz",
        "website": "www.absolon.cz",
        "lat": 50.0924,
        "lng": 14.4518,
        "cert": "Authorized Regional Alarm & CCTV Distributor"
    },
    {
        "id": 4,
        "name": "IPSECURITY s.r.o.",
        "category": "distributor",
        "country": "CZ",
        "region": "cz",
        "city": "Prague, Czech Republic",
        "address": "Trojmezní 46, 190 00 Praha 9",
        "contact": "Pavel Skřivánek",
        "phone": "+420 284 810 820",
        "email": "info@ipsecurity.cz",
        "website": "www.ipsecurity.cz",
        "lat": 50.1256,
        "lng": 14.4812,
        "cert": "IP Video & Acoustic Surveillance Specialist"
    },
    {
        "id": 5,
        "name": "Alpha-Omega Technology GmbH & Co. KG",
        "category": "distributor",
        "country": "DE",
        "region": "de",
        "city": "Schimberg, Germany",
        "address": "Flinsberger Straße 27, 37308 Schimberg",
        "contact": "DACH IoT Operations",
        "phone": "+49 36082 84900",
        "email": "info@iot-shop.de",
        "website": "www.alpha-omega-technology.de",
        "lat": 51.2721,
        "lng": 10.0825,
        "cert": "Authorized DACH Distributor & IoT Portal"
    },
    {
        "id": 6,
        "name": "Technology and Innovation 2022, LLC",
        "category": "distributor",
        "country": "UA",
        "region": "ua",
        "city": "Kiev, Ukraine",
        "address": "Kiev, Ukraine",
        "contact": "Mykhailo Makarov",
        "phone": "+380 44 555 0199",
        "email": "m.makarov@t-i.com.ua",
        "website": "www.t-i.com.ua",
        "lat": 50.4501,
        "lng": 30.5234,
        "cert": "Official Ukraine Master Distributor"
    },
    {
        "id": 7,
        "name": "Albion alarm, spol. s r.o.",
        "category": "distributor",
        "country": "CZ",
        "region": "cz",
        "city": "Ostrava, Czech Republic",
        "address": "Výstaviště Černá louka 1167, 702 00 Ostrava",
        "contact": "Albion Commercial Desk",
        "phone": "+420 608 738 361",
        "email": "albion@albionalarm.cz",
        "website": "www.albionalarm.cz",
        "lat": 49.8312,
        "lng": 18.2881,
        "cert": "Moravian Security Systems Distributor"
    },
    {
        "id": 8,
        "name": "KELCOM International spol. s r.o.",
        "category": "distributor",
        "country": "CZ",
        "region": "cz",
        "city": "Hradec Králové, Czech Republic",
        "address": "Tomkova 316, 500 03 Hradec Králové",
        "contact": "Ing. Jaroslav Černý",
        "phone": "+420 495 513 513",
        "email": "kelcom@kelcom.cz",
        "website": "www.kelcom.cz",
        "lat": 50.2104,
        "lng": 15.8328,
        "cert": "Security & Telecom Systems Distributor"
    },
    {
        "id": 9,
        "name": "SEFOR Solutions s.r.o.",
        "category": "distributor",
        "country": "CZ",
        "region": "cz",
        "city": "Prague, Czech Republic",
        "address": "V Pláni 58/32, 142 00 Praha 4",
        "contact": "Ing. Radek Foniok",
        "phone": "+420 731 670 510",
        "email": "info@sefor.cz",
        "website": "www.sefor.cz",
        "lat": 50.0281,
        "lng": 14.4412,
        "cert": "Defense, Security & Tactical Distributor"
    },
    {
        "id": 10,
        "name": "FSM Group Oy (FSM.FI)",
        "category": "distributor",
        "country": "FI",
        "region": "nordics",
        "city": "Vantaa / Helsinki, Finland",
        "address": "Niittyvillankuja 4, 01510 Vantaa",
        "contact": "Nordic Sales Desk",
        "phone": "+358 207 559 500",
        "email": "myynti@fsm.fi",
        "website": "www.fsm.fi",
        "lat": 60.2934,
        "lng": 24.9668,
        "cert": "Nordic Security & CCTV Distributor"
    },
    {
        "id": 11,
        "name": "WIMAX Sp. z o.o.",
        "category": "distributor",
        "country": "PL",
        "region": "de",
        "city": "Warsaw, Poland",
        "address": "ul. Walecznych 68A, 03-926 Warszawa",
        "contact": "Piotr Wójcik",
        "phone": "+48 22 617 80 50",
        "email": "biuro@wimax.com.pl",
        "website": "www.wimax.com.pl",
        "lat": 52.2371,
        "lng": 21.0581,
        "cert": "Authorized Polish Security Distributor"
    },
    {
        "id": 12,
        "name": "Geutebruck (UK) Limited",
        "category": "integrator",
        "country": "UK",
        "region": "uk",
        "city": "Buckingham, UK",
        "address": "Unit 16, Apollo Business Park, Radclive Rd, Gawcott MK18 4DF",
        "contact": "Darren Cunliffe",
        "phone": "+44 1280 822550",
        "email": "info@geutebruck.co.uk",
        "website": "www.geutebruck.co.uk",
        "lat": 51.9961,
        "lng": -1.0021,
        "cert": "Certified VMS & Enterprise Video Integrator"
    },
    {
        "id": 13,
        "name": "Remark AI UK Limited",
        "category": "integrator",
        "country": "UK",
        "region": "uk",
        "city": "London, UK",
        "address": "New Kings Beam House, 22 Upper Ground, London SE1 9PD",
        "contact": "Dr. Xiaoyun Yang",
        "phone": "+44 20 7928 8800",
        "email": "xiaoyun.yang@remarkai.co.uk",
        "website": "www.remarkai.co.uk",
        "lat": 51.5074,
        "lng": -0.1082,
        "cert": "AI Smart City & Acoustic Analytics Partner"
    },
    {
        "id": 14,
        "name": "DSSL Group",
        "category": "integrator",
        "country": "UK",
        "region": "uk",
        "city": "Basildon, Essex, UK",
        "address": "1-3 Brittania Ct, Burnt Mills Ind. Estate, Basildon SS13 1EU",
        "contact": "Aaron Stephens",
        "phone": "+44 1268 726666",
        "email": "admin@dsslgroup.co.uk",
        "website": "www.dsslgroup.co.uk",
        "lat": 51.5712,
        "lng": 0.4912,
        "cert": "Public Sector CCTV & Municipal Integrator"
    },
    {
        "id": 15,
        "name": "221B GROUP LIMITED",
        "category": "integrator",
        "country": "UK",
        "region": "uk",
        "city": "Chelmsford, Essex, UK",
        "address": "Suite 215 Waterhouse Business Centre, Cromar Way, Chelmsford CM1 2QE",
        "contact": "Mark Thorne",
        "phone": "+44 1245 922100",
        "email": "mark@221bgroup.co.uk",
        "website": "www.221bgroup.co.uk",
        "lat": 51.7341,
        "lng": 0.4681,
        "cert": "Critical Infrastructure Security Partner"
    },
    {
        "id": 16,
        "name": "APS Aegis Ltd",
        "category": "integrator",
        "country": "UK",
        "region": "uk",
        "city": "Hull / East Yorkshire, UK",
        "address": "Unit 2, The Triangle, Wilderspool Causeway, Warrington WA4 6PS",
        "contact": "Michael Hill",
        "phone": "+44 1482 654321",
        "email": "info@apsaegis.co.uk",
        "website": "www.apsaegis.co.uk",
        "lat": 53.385,
        "lng": -2.597,
        "cert": "Perimeter Security & High-Security Systems"
    },
    {
        "id": 17,
        "name": "Emergency Protection Limited",
        "category": "integrator",
        "country": "UK",
        "region": "uk",
        "city": "Henley-in-Arden, UK",
        "address": "Forward House, 17 High Street, Henley-in-Arden B95 5AA",
        "contact": "Operations Director",
        "phone": "+44 1564 797700",
        "email": "info@emergencyprotection.co.uk",
        "website": "www.emergencyprotection.co.uk",
        "lat": 52.2905,
        "lng": -1.7788,
        "cert": "Rapid Deployment & Emergency Protection Systems"
    },
    {
        "id": 18,
        "name": "Westminster Group PLC",
        "category": "integrator",
        "country": "UK",
        "region": "uk",
        "city": "Banbury, Oxfordshire, UK",
        "address": "Westminster House, Blacklocks Hill, Banbury OX17 2BS",
        "contact": "International Sales Desk",
        "phone": "+44 1295 756300",
        "email": "info@wsg-corporate.com",
        "website": "www.wsg-corporate.com",
        "lat": 52.0629,
        "lng": -1.3398,
        "cert": "Global Homeland Security & Defense Integrator"
    },
    {
        "id": 19,
        "name": "Irisity AB (UK & Global)",
        "category": "integrator",
        "country": "UK",
        "region": "uk",
        "city": "London & Gothenburg",
        "address": "Lindholmspiren 7, 417 56 Göteborg / London Office",
        "contact": "Peter Greener",
        "phone": "+46 771 41 11 00",
        "email": "peter.greener@irisity.com",
        "website": "www.irisity.com",
        "lat": 51.5074,
        "lng": -0.1278,
        "cert": "AI Video Analytics & Sound Integration Partner"
    },
    {
        "id": 20,
        "name": "VIS Security Solutions Ltd",
        "category": "integrator",
        "country": "UK",
        "region": "uk",
        "city": "Belfast, Northern Ireland, UK",
        "address": "Unit 2, Townsend Enterprise Park, Belfast BT13 2ES",
        "contact": "Integration Services Desk",
        "phone": "+44 28 9031 3550",
        "email": "info@vis-security.com",
        "website": "www.vis-security.com",
        "lat": 54.5973,
        "lng": -5.9301,
        "cert": "Integrated Electronic Security Partner"
    },
    {
        "id": 21,
        "name": "Active CCTV Limited",
        "category": "integrator",
        "country": "UK",
        "region": "uk",
        "city": "Sheffield, UK",
        "address": "Unit 4, Magna 34 Business Park, Sheffield S60 1DX",
        "contact": "Engineering Desk",
        "phone": "+44 114 251 1010",
        "email": "info@activecctv.co.uk",
        "website": "www.activecctv.co.uk",
        "lat": 53.3811,
        "lng": -1.4701,
        "cert": "CCTV & Security Integration Specialist"
    },
    {
        "id": 22,
        "name": "MITEL spol. s r.o.",
        "category": "integrator",
        "country": "CZ",
        "region": "cz",
        "city": "Prague, Czech Republic",
        "address": "Dobrušská 1797/1, 147 00 Praha 4",
        "contact": "Jakub Večeřa",
        "phone": "+420 734 437 872",
        "email": "vecera@mitel.cz",
        "website": "www.mitel.cz",
        "lat": 50.0412,
        "lng": 14.4123,
        "cert": "Certified Smart City & VMS Integrator"
    },
    {
        "id": 23,
        "name": "M2C (Mark2 Corporation Czech a.s.)",
        "category": "integrator",
        "country": "CZ",
        "region": "cz",
        "city": "Prague, Czech Republic",
        "address": "Vladislavova 17, 110 00 Praha 1",
        "contact": "Kateřina Kulíšková",
        "phone": "+420 702 297 453",
        "email": "k.kuliskova@m2c.eu",
        "website": "www.m2c.eu",
        "lat": 50.0812,
        "lng": 14.4211,
        "cert": "International Facility & Smart Security Integrator"
    },
    {
        "id": 24,
        "name": "DESA group s.r.o.",
        "category": "integrator",
        "country": "CZ",
        "region": "cz",
        "city": "Prague, Czech Republic",
        "address": "Revoluční 762/13, 110 00 Praha 1",
        "contact": "Roman Bruník",
        "phone": "+420 774 112 174",
        "email": "info@desagroup.cz",
        "website": "www.desagroup.cz",
        "lat": 50.0901,
        "lng": 14.4282,
        "cert": "Complex Electronic Security Systems Integrator"
    },
    {
        "id": 25,
        "name": "IQ Group Česko, a.s.",
        "category": "integrator",
        "country": "CZ",
        "region": "cz",
        "city": "Prague & Ostrava, Czech Republic",
        "address": "Podnikatelská 539, 190 11 Praha - Běchovice",
        "contact": "Martin Ležovič",
        "phone": "+420 777 895 611",
        "email": "martin.lezovic@iqgroup.eu",
        "website": "www.iqgroup.eu",
        "lat": 50.0805,
        "lng": 14.5902,
        "cert": "Enterprise Security & Infrastructure Integrator"
    },
    {
        "id": 26,
        "name": "SCANLOCK CZ, spol. s r.o.",
        "category": "integrator",
        "country": "CZ",
        "region": "cz",
        "city": "Brno, Czech Republic",
        "address": "Březinova 1608/42, 616 00 Brno",
        "contact": "Ondřej Linduška",
        "phone": "+420 515 917 917",
        "email": "ondrej.linduska@scanlock.cz",
        "website": "www.scanlock.cz",
        "lat": 49.2081,
        "lng": 16.5784,
        "cert": "Access Control & Acoustic Perimeter Integrator"
    },
    {
        "id": 27,
        "name": "OVANET a.s.",
        "category": "integrator",
        "country": "CZ",
        "region": "cz",
        "city": "Ostrava, Czech Republic",
        "address": "Hájkova 1100/13, 702 00 Ostrava",
        "contact": "Radana Lašová",
        "phone": "+420 734 262 006",
        "email": "lasova@ovanet.cz",
        "website": "www.ovanet.cz",
        "lat": 49.8354,
        "lng": 18.2924,
        "cert": "Municipal Smart City Fiber & Camera Integrator"
    },
    {
        "id": 28,
        "name": "MC Systems & Services s.r.o.",
        "category": "integrator",
        "country": "CZ",
        "region": "cz",
        "city": "Prague, Czech Republic",
        "address": "Weilova 1144, 102 00 Praha 15",
        "contact": "Ing. Martin Chmelík",
        "phone": "+420 274 810 900",
        "email": "info@mcsystems.cz",
        "website": "www.mcsystems.cz",
        "lat": 50.0521,
        "lng": 14.5381,
        "cert": "Security Integration & Surveillance Partner"
    },
    {
        "id": 29,
        "name": "Special Service International s.r.o. (SSI Group)",
        "category": "integrator",
        "country": "CZ",
        "region": "cz",
        "city": "Prague, Czech Republic",
        "address": "Letohradská 711/10, 170 00 Praha 7",
        "contact": "Operations & Tech Desk",
        "phone": "+420 220 570 050",
        "email": "info@ssi.cz",
        "website": "www.ssi.cz",
        "lat": 50.0987,
        "lng": 14.4312,
        "cert": "Integrated Physical & Electronic Security Partner"
    },
    {
        "id": 30,
        "name": "Base system spol. s r.o.",
        "category": "integrator",
        "country": "CZ",
        "region": "cz",
        "city": "Hodonín, Czech Republic",
        "address": "Brněnská 3975, 695 01 Hodonín",
        "contact": "Ing. Petr Svoboda",
        "phone": "+420 518 340 010",
        "email": "info@basesystem.cz",
        "website": "www.basesystem.cz",
        "lat": 48.8572,
        "lng": 17.1324,
        "cert": "Comprehensive Alarm & Security Integrator"
    },
    {
        "id": 31,
        "name": "Colsys s.r.o.",
        "category": "integrator",
        "country": "CZ",
        "region": "cz",
        "city": "Kladno & Prague, Czech Republic",
        "address": "Buštěhradská 109, 272 03 Kladno",
        "contact": "Prague Engineering Office",
        "phone": "+420 272 181 522",
        "email": "praha@colsys.cz",
        "website": "www.colsys.cz",
        "lat": 50.1481,
        "lng": 14.1352,
        "cert": "Industrial Automation & Complex Security Integrator"
    },
    {
        "id": 32,
        "name": "NSN CS s.r.o.",
        "category": "integrator",
        "country": "CZ",
        "region": "cz",
        "city": "Hodonín, Czech Republic",
        "address": "Na Pískách 3234/1, 695 01 Hodonín",
        "contact": "Technical Desk",
        "phone": "+420 518 309 911",
        "email": "nsncs@nsncs.cz",
        "website": "www.nsncs.cz",
        "lat": 48.8612,
        "lng": 17.1298,
        "cert": "Telecommunications & Security Systems Partner"
    },
    {
        "id": 33,
        "name": "Digilive s.r.o.",
        "category": "integrator",
        "country": "CZ",
        "region": "cz",
        "city": "Kunovice, Czech Republic",
        "address": "V Humnech 1590, 686 04 Kunovice",
        "contact": "Sales Department",
        "phone": "+420 601 580 620",
        "email": "sales@idigilive.com",
        "website": "www.idigilive.com",
        "lat": 49.0432,
        "lng": 17.4712,
        "cert": "Smart Living & Security Automation Integrator"
    },
    {
        "id": 34,
        "name": "EKON-SYS s.r.o.",
        "category": "integrator",
        "country": "CZ",
        "region": "cz",
        "city": "Trutnov, Czech Republic",
        "address": "Veleslavínova 66, 541 01 Trutnov",
        "contact": "Pavel Novosvětský",
        "phone": "+420 725 103 293",
        "email": "pavel@ekonsys.cz",
        "website": "www.ekonsys.cz",
        "lat": 50.5621,
        "lng": 15.9123,
        "cert": "Certified Camera & Acoustic Alarm Integrator"
    },
    {
        "id": 35,
        "name": "Integoo s.r.o.",
        "category": "integrator",
        "country": "CZ",
        "region": "cz",
        "city": "Prague, Czech Republic",
        "address": "Truhlářská 1520/23, 110 00 Praha 1",
        "contact": "Integration Services Team",
        "phone": "+420 222 718 100",
        "email": "info@integoo.cz",
        "website": "www.integoo.cz",
        "lat": 50.0912,
        "lng": 14.4298,
        "cert": "Smart Building & Integrated Security Systems"
    },
    {
        "id": 36,
        "name": "Efektit system s.r.o.",
        "category": "integrator",
        "country": "CZ",
        "region": "cz",
        "city": "Plzeň, Czech Republic",
        "address": "Borská 2187/8, 301 00 Plzeň",
        "contact": "Ing. Jan Štrunc",
        "phone": "+420 374 802 533",
        "email": "info@efektit.cz",
        "website": "www.efektit.cz",
        "lat": 49.7412,
        "lng": 13.3712,
        "cert": "Regional West Bohemian Security & IT Integrator"
    },
    {
        "id": 37,
        "name": "SECURITY REDON Plus s.r.o.",
        "category": "integrator",
        "country": "CZ",
        "region": "cz",
        "city": "Havířov, Czech Republic",
        "address": "Kollárova 1651/2a, 736 01 Havířov",
        "contact": "Redon Security Desk",
        "phone": "+420 596 420 471",
        "email": "info@redonplus.cz",
        "website": "www.redonplus.cz",
        "lat": 49.7781,
        "lng": 18.4312,
        "cert": "Silesian Alarm & Surveillance Integrator"
    },
    {
        "id": 38,
        "name": "VDT Technology a.s.",
        "category": "integrator",
        "country": "CZ",
        "region": "cz",
        "city": "Prague, Czech Republic",
        "address": "Na Ořechovce 580/4, 162 00 Praha 6",
        "contact": "VDT Integration Office",
        "phone": "+420 277 004 040",
        "email": "info@vdttechnology.com",
        "website": "www.vdttechnology.com",
        "lat": 50.0954,
        "lng": 14.3781,
        "cert": "High-Tech IoT & Smart Urban Sensor Integrator"
    },
    {
        "id": 39,
        "name": "Czechoslovak Group (CSG - Excalibur Army & International)",
        "category": "integrator",
        "country": "CZ",
        "region": "cz",
        "city": "Pardubice & Prague, Czech Republic",
        "address": "Kodaňská 1441/46, 101 00 Praha 10",
        "contact": "Defense Security Division",
        "phone": "+420 466 799 111",
        "email": "sep@csgm.cz",
        "website": "www.czechoslovakgroup.com",
        "lat": 50.0712,
        "lng": 14.4589,
        "cert": "Strategic Defense & Homeland Security Partner"
    },
    {
        "id": 40,
        "name": "ONE SYSTEM s.r.o.",
        "category": "integrator",
        "country": "CZ",
        "region": "cz",
        "city": "Prague, Czech Republic",
        "address": "U Hellady 697/4, 140 00 Praha 4",
        "contact": "Ing. Milan Dvořák",
        "phone": "+420 241 400 900",
        "email": "info@onesystem.cz",
        "website": "www.onesystem.cz",
        "lat": 50.052,
        "lng": 14.453,
        "cert": "Complex Electronic Security Systems Partner"
    },
    {
        "id": 41,
        "name": "ATKM s.r.o.",
        "category": "integrator",
        "country": "CZ",
        "region": "cz",
        "city": "Prague, Czech Republic",
        "address": "Vídeňská 101/119, 140 00 Praha 4",
        "contact": "Commercial Team",
        "phone": "+420 244 472 200",
        "email": "info@atkm.cz",
        "website": "www.atkm.cz",
        "lat": 50.024,
        "lng": 14.46,
        "cert": "Security Integration & Camera Solutions"
    },
    {
        "id": 42,
        "name": "Maxprogres s.r.o.",
        "category": "integrator",
        "country": "CZ",
        "region": "cz",
        "city": "Brno, Czech Republic",
        "address": "Traťová 1, 619 00 Brno",
        "contact": "Petr Krišt",
        "phone": "+420 543 424 711",
        "email": "petr.krist@maxprogres.cz",
        "website": "www.maxprogres.cz",
        "lat": 49.168,
        "lng": 16.602,
        "cert": "Telecom, Fiber & Urban Sensor Integrator"
    },
    {
        "id": 43,
        "name": "RETIA a.s.",
        "category": "integrator",
        "country": "CZ",
        "region": "cz",
        "city": "Pardubice, Czech Republic",
        "address": "Pražská 341, 530 02 Pardubice",
        "contact": "Radar & Sensor Division",
        "phone": "+420 466 852 111",
        "email": "info@retia.cz",
        "website": "www.retia.cz",
        "lat": 50.0343,
        "lng": 15.7812,
        "cert": "Specialized Defense Electronics & Radar Partner"
    },
    {
        "id": 44,
        "name": "JISR Institute a.s.",
        "category": "integrator",
        "country": "CZ",
        "region": "cz",
        "city": "Prague, Czech Republic",
        "address": "Evropská 846/176a, 160 00 Praha 6",
        "contact": "Research & Defense Division",
        "phone": "+420 220 180 500",
        "email": "info@jisr-institute.org",
        "website": "www.jisr-institute.org",
        "lat": 50.0965,
        "lng": 14.3421,
        "cert": "Acoustic Signal Processing & Defense R&D Partner"
    },
    {
        "id": 45,
        "name": "Neuron Soundware s.r.o.",
        "category": "integrator",
        "country": "CZ",
        "region": "cz",
        "city": "Prague, Czech Republic",
        "address": "Thákurova 531/4, 160 00 Praha 6",
        "contact": "Acoustic AI Team",
        "phone": "+420 222 360 800",
        "email": "info@neuronsw.com",
        "website": "www.neuronsw.com",
        "lat": 50.103,
        "lng": 14.389,
        "cert": "Industrial Acoustic AI & Machinery Diagnostic Partner"
    },
    {
        "id": 46,
        "name": "Defenguard s.r.o.",
        "category": "integrator",
        "country": "SK",
        "region": "nordics",
        "city": "Martin, Slovakia",
        "address": "Sučianska 2095/3, 036 01 Martin",
        "contact": "Ing. Juraj Matúš",
        "phone": "+421 907 653 602",
        "email": "info@defenguard.com",
        "website": "www.defenguard.com",
        "lat": 49.0641,
        "lng": 18.9212,
        "cert": "Slovakia Defense & Perimeter Integrator"
    },
    {
        "id": 47,
        "name": "TSS Group a.s.",
        "category": "integrator",
        "country": "SK",
        "region": "nordics",
        "city": "Dubnica nad Váhom & Bratislava, Slovakia",
        "address": "Továrenská 4201/50, 018 41 Dubnica nad Váhom",
        "contact": "Technical Sales Division",
        "phone": "+421 42 445 00 10",
        "email": "info@tssgroup.sk",
        "website": "www.tssgroup.sk",
        "lat": 48.9602,
        "lng": 18.1755,
        "cert": "GPS, Fleet & Security Systems Integrator"
    },
    {
        "id": 48,
        "name": "Novatel Sp. z o.o.",
        "category": "integrator",
        "country": "PL",
        "region": "de",
        "city": "Bieruń / Katowice, Poland",
        "address": "ul. Turystyczna 1, 43-155 Bieruń",
        "contact": "Novatel Technical Desk",
        "phone": "+48 32 201 17 04",
        "email": "novatel@novatel.pl",
        "website": "www.novatel.pl",
        "lat": 50.0881,
        "lng": 19.0912,
        "cert": "Telemetry, CCTV & Remote Monitoring Partner"
    },
    {
        "id": 49,
        "name": "Arup Polska Sp. z o.o.",
        "category": "integrator",
        "country": "PL",
        "region": "de",
        "city": "Warsaw & Krakow, Poland",
        "address": "ul. Inflancka 4, 00-189 Warszawa",
        "contact": "Smart Cities & Acoustic Engineering",
        "phone": "+48 22 455 58 00",
        "email": "warsaw@arup.com",
        "website": "www.arup.com",
        "lat": 52.253,
        "lng": 20.995,
        "cert": "Global Consulting & Acoustic Architecture Partner"
    },
    {
        "id": 50,
        "name": "Syneo Kft.",
        "category": "integrator",
        "country": "HU",
        "region": "de",
        "city": "Budapest, Hungary",
        "address": "Fehérvári út 84/A, 1119 Budapest",
        "contact": "Syneo Technical Support",
        "phone": "+36 1 453 7100",
        "email": "info@syneo.hu",
        "website": "www.syneo.hu",
        "lat": 47.4625,
        "lng": 19.0375,
        "cert": "Hungarian Security & Low-Voltage Integrator"
    },
    {
        "id": 51,
        "name": "Analytiqum Security S.R.L.",
        "category": "integrator",
        "country": "RO",
        "region": "de",
        "city": "Bucharest, Romania",
        "address": "Str. Nicolae Caramfil 71-73, 014142 București",
        "contact": "Bogdan Popescu",
        "phone": "+40 21 230 4500",
        "email": "office@analytiqum.ro",
        "website": "www.analytiqum.ro",
        "lat": 44.482,
        "lng": 26.089,
        "cert": "Romanian Video Analytics & Sound Integrator"
    },
    {
        "id": 52,
        "name": "Syntegra Security S.R.L.",
        "category": "integrator",
        "country": "RO",
        "region": "de",
        "city": "Cluj-Napoca, Romania",
        "address": "Calea Dorobanților 114, 400609 Cluj-Napoca",
        "contact": "Adrian Munteanu",
        "phone": "+40 364 800 900",
        "email": "contact@syntegra.ro",
        "website": "www.syntegra.ro",
        "lat": 46.7712,
        "lng": 23.608,
        "cert": "Enterprise IP Surveillance & Sound Partner"
    },
    {
        "id": 53,
        "name": "Siemens AG Austria (SI B Austria)",
        "category": "integrator",
        "country": "AT",
        "region": "de",
        "city": "Vienna, Austria",
        "address": "Siemensstraße 90, 1210 Wien",
        "contact": "Building Products & Smart Infrastructure",
        "phone": "+43 51707 0",
        "email": "info.at@siemens.com",
        "website": "www.siemens.at",
        "lat": 48.278,
        "lng": 16.425,
        "cert": "Certified Smart Infrastructure & Safety Partner"
    },
    {
        "id": 54,
        "name": "Sitrac AG",
        "category": "integrator",
        "country": "CH",
        "region": "de",
        "city": "Zurich / Baar, Switzerland",
        "address": "Lindenstrasse 16, 6340 Baar / Zurich",
        "contact": "Andreas Ceccon",
        "phone": "+41 41 768 00 20",
        "email": "info@sitrac.ch",
        "website": "www.sitrac.ch",
        "lat": 47.195,
        "lng": 8.528,
        "cert": "Swiss High-End Traffic & Security Integrator"
    },
    {
        "id": 55,
        "name": "Tradesegur S.A.",
        "category": "integrator",
        "country": "ES",
        "region": "es",
        "city": "Madrid, Spain",
        "address": "C. de la Granja, 30, 28108 Alcobendas, Madrid",
        "contact": "Carlos Gómez",
        "phone": "+34 913 605 123",
        "email": "info@tradesegur.com",
        "website": "www.tradesegur.com",
        "lat": 40.5281,
        "lng": -3.6421,
        "cert": "Spanish Traffic, Police & Municipal Integrator"
    },
    {
        "id": 56,
        "name": "MARCOM INTEGRALES DE SISTEMAS, S.L.",
        "category": "integrator",
        "country": "ES",
        "region": "es",
        "city": "Madrid & Barcelona, Spain",
        "address": "Av. de Manoteras, 24, 28050 Madrid",
        "contact": "Elchin Niftullayev",
        "phone": "+34 91 768 01 20",
        "email": "elchin@marids.com",
        "website": "www.marids.com",
        "lat": 40.489,
        "lng": -3.665,
        "cert": "Turn-Key Defense & Security Systems Integrator"
    },
    {
        "id": 57,
        "name": "SICE (Sociedad Ibérica de Construcciones Eléctricas)",
        "category": "integrator",
        "country": "ES",
        "region": "es",
        "city": "Madrid, Spain",
        "address": "C/ Sepúlveda 6, Pol. Ind. Alcobendas, 28108 Madrid",
        "contact": "Smart Cities Division",
        "phone": "+34 91 623 22 00",
        "email": "sice@sice.com",
        "website": "www.sice.com",
        "lat": 40.534,
        "lng": -3.638,
        "cert": "Global Intelligent Transportation & Smart City Integrator"
    },
    {
        "id": 58,
        "name": "Almaviva S.p.A.",
        "category": "integrator",
        "country": "IT",
        "region": "es",
        "city": "Rome & Milan, Italy",
        "address": "Via di Casal Boccone 188-190, 00137 Roma",
        "contact": "Enterprise Digital Division",
        "phone": "+39 06 3993 1",
        "email": "info@almaviva.it",
        "website": "www.almaviva.it",
        "lat": 41.9712,
        "lng": 12.5481,
        "cert": "Italian Multinational Enterprise & Defense Integrator"
    },
    {
        "id": 59,
        "name": "Arteco Global (Arteco S.r.l.)",
        "category": "integrator",
        "country": "IT",
        "region": "es",
        "city": "Faenza / Bologna, Italy",
        "address": "Via Mobili 1, 48018 Faenza (RA)",
        "contact": "VMS Product Management",
        "phone": "+39 0546 645770",
        "email": "info@arteco-global.com",
        "website": "www.arteco-global.com",
        "lat": 44.285,
        "lng": 11.882,
        "cert": "Video Event Management Software Pioneer"
    },
    {
        "id": 60,
        "name": "Sicurit Alarmitalia S.p.A.",
        "category": "integrator",
        "country": "IT",
        "region": "es",
        "city": "Milan, Italy",
        "address": "Via C. Battisti 58, 20090 Trezzano sul Naviglio (MI)",
        "contact": "Paolo Barzaghi",
        "phone": "+39 02 4840 5000",
        "email": "sicurit@sicurit.it",
        "website": "www.sicurit.it",
        "lat": 45.426,
        "lng": 9.068,
        "cert": "Perimeter Protection & Acoustic Sensor Integrator"
    },
    {
        "id": 61,
        "name": "The Safe Group",
        "category": "integrator",
        "country": "BE",
        "region": "de",
        "city": "Hasselt / Brussels, Belgium",
        "address": "Gouverneur Verwilghensingel 38, 3500 Hasselt",
        "contact": "Customer Success Team",
        "phone": "+32 11 96 00 00",
        "email": "hello@thesafegroup.com",
        "website": "www.thesafegroup.com",
        "lat": 50.931,
        "lng": 5.358,
        "cert": "Belgian Smart City & Temporary CCTV Specialist"
    },
    {
        "id": 62,
        "name": "Remoticom B.V.",
        "category": "integrator",
        "country": "NL",
        "region": "de",
        "city": "Tilburg / Eindhoven, Netherlands",
        "address": "De Vlashoeve 34, 5062 KS Oisterwijk",
        "contact": "Smart Lighting & IoT Desk",
        "phone": "+31 85 021 2100",
        "email": "info@remoticom.com",
        "website": "www.remoticom.com",
        "lat": 51.581,
        "lng": 5.197,
        "cert": "Smart Streetlight Acoustic Sensor Partner"
    },
    {
        "id": 63,
        "name": "Sorama B.V.",
        "category": "integrator",
        "country": "NL",
        "region": "de",
        "city": "Eindhoven, Netherlands",
        "address": "Torenallee 20, 5617 BC Eindhoven (Strijp-S)",
        "contact": "Dr. Rick Scholte",
        "phone": "+31 40 304 1010",
        "email": "info@sorama.eu",
        "website": "www.sorama.eu",
        "lat": 51.448,
        "lng": 5.456,
        "cert": "Acoustic Camera & Environmental Noise Partner"
    },
    {
        "id": 64,
        "name": "sensiBel AS",
        "category": "integrator",
        "country": "NO",
        "region": "nordics",
        "city": "Oslo, Norway",
        "address": "Gaustadalléen 21, 0349 Oslo",
        "contact": "Tom Hazlett",
        "phone": "+47 22 85 50 00",
        "email": "marketing@sensibel.com",
        "website": "www.sensibel.com",
        "lat": 59.943,
        "lng": 10.718,
        "cert": "Next-Gen Optical MEMS Microphone Technology Partner"
    },
    {
        "id": 65,
        "name": "Mondot SIA",
        "category": "integrator",
        "country": "LV",
        "region": "nordics",
        "city": "Riga, Latvia",
        "address": "Dzelzavas iela 117, Rīga, LV-1021",
        "contact": "Mārtiņš Danovskis",
        "phone": "+371 67 800 900",
        "email": "info@mondot.lv",
        "website": "www.mondot.lv",
        "lat": 56.961,
        "lng": 24.182,
        "cert": "Baltic Industrial Automation & Surveillance Integrator"
    },
    {
        "id": 66,
        "name": "UAB \"VS sistemos\"",
        "category": "integrator",
        "country": "LT",
        "region": "nordics",
        "city": "Vilnius, Lithuania",
        "address": "J. Kubiliaus g. 21, LT-08238 Vilnius",
        "contact": "Vytautas Staniulis",
        "phone": "+370 5 278 8800",
        "email": "info@vssistemos.lt",
        "website": "www.vssistemos.lt",
        "lat": 54.712,
        "lng": 25.295,
        "cert": "Lithuanian CCTV & Security Engineering Partner"
    },
    {
        "id": 67,
        "name": "ClearWorld LLC",
        "country": "US",
        "category": "integrator",
        "region": "us",
        "city": "New Orleans, LA, USA",
        "address": "400 Poydras St, Suite 1975, New Orleans, LA 70130",
        "contact": "Larry Tittle",
        "phone": "+1 888 886 4434",
        "email": "info@clearworld.net",
        "website": "www.clearworld.net",
        "lat": 29.949,
        "lng": -90.069,
        "cert": "Solar Smart Pole & Urban Safety Integrator"
    },
    {
        "id": 68,
        "name": "Team 1st Technologies LLC",
        "category": "integrator",
        "country": "US",
        "region": "us",
        "city": "Albuquerque, NM, USA",
        "address": "4320 Alexander Blvd NE, Suite A, Albuquerque, NM 87107",
        "contact": "Bruce W. Evans",
        "phone": "+1 505 341 4410",
        "email": "info@team1st.com",
        "website": "www.team1st.com",
        "lat": 35.132,
        "lng": -106.602,
        "cert": "Public Safety, Education & Campus Audio Integrator"
    },
    {
        "id": 69,
        "name": "Fog Armed Security Systems",
        "category": "integrator",
        "country": "US",
        "region": "us",
        "city": "Orlando, FL, USA",
        "address": "7901 Kingspointe Pkwy, Suite 18, Orlando, FL 32819",
        "contact": "David Miller",
        "phone": "+1 407 555 8900",
        "email": "info@fogarmed.com",
        "website": "www.fogarmed.com",
        "lat": 28.448,
        "lng": -81.442,
        "cert": "Active Defense & Anti-Intruder Fog Solutions"
    },
    {
        "id": 70,
        "name": "Custom Video Security (eDigitalDeals, Inc.)",
        "category": "integrator",
        "country": "US",
        "region": "us",
        "city": "Los Angeles, CA, USA",
        "address": "21038 Higgins Ct, Torrance, CA 90501",
        "contact": "Raymond Khavari",
        "phone": "+1 310 370 9500",
        "email": "sales@customvideosecurity.com",
        "website": "www.customvideosecurity.com",
        "lat": 33.842,
        "lng": -118.328,
        "cert": "Commercial IP Surveillance & Sound Analytics Provider"
    },
    {
        "id": 71,
        "name": "HSC Group LLC",
        "category": "integrator",
        "country": "US",
        "region": "us",
        "city": "Dallas, TX, USA",
        "address": "14180 Dallas Pkwy, Suite 500, Dallas, TX 75254",
        "contact": "Corporate Security Division",
        "phone": "+1 972 555 0140",
        "email": "info@hscgroup.com",
        "website": "www.hscgroup.com",
        "lat": 32.941,
        "lng": -96.822,
        "cert": "Enterprise Asset Protection & High-Security Systems"
    },
    {
        "id": 72,
        "name": "Columbia Security Systems & Solutions Ltd",
        "category": "integrator",
        "country": "CA",
        "region": "us",
        "city": "Vancouver, BC, Canada",
        "address": "1199 W Pender St, Suite 800, Vancouver, BC V6E 2R1",
        "contact": "Ashley Meehan",
        "phone": "+1 604 688 8900",
        "email": "info@columbiasecurity.ca",
        "website": "www.columbiasecurity.ca",
        "lat": 49.287,
        "lng": -123.122,
        "cert": "Western Canada Security & Facility Integrator"
    },
    {
        "id": 73,
        "name": "Uncrewed Systems Inc. (USI)",
        "category": "integrator",
        "country": "CA",
        "region": "us",
        "city": "Calgary / Toronto, Canada",
        "address": "400 3 Ave SW, Calgary, AB T2P 4H2",
        "contact": "Drone Defense Group",
        "phone": "+1 403 555 0188",
        "email": "info@uncrewedsystems.ca",
        "website": "www.uncrewedsystems.ca",
        "lat": 51.05,
        "lng": -114.071,
        "cert": "Anti-Drone Acoustic Airspace & Perimeter Protection"
    },
    {
        "id": 74,
        "name": "SICE AGENCIA CHILE SA",
        "category": "integrator",
        "country": "CL",
        "region": "us",
        "city": "Santiago, Chile",
        "address": "Dardignac n. 160, 8420509, Recoleta, Santiago",
        "contact": "Concesiones y Tráfico",
        "phone": "+56 2 2489 1200",
        "email": "sice@sice.com",
        "website": "www.sice.com",
        "lat": -33.4372,
        "lng": -70.6481,
        "cert": "South American Highway & Urban Surveillance Integrator"
    },
    {
        "id": 75,
        "name": "InfoKrause (Jorge Krause)",
        "category": "integrator",
        "country": "CL",
        "region": "us",
        "city": "Viña del Mar / Santiago, Chile",
        "address": "Av. Libertad 269, Viña del Mar, Valparaíso",
        "contact": "Jorge Krause",
        "phone": "+56 9 9876 5432",
        "email": "jkrause@infokrause.cl",
        "website": "www.infokrause.cl",
        "lat": -33.015,
        "lng": -71.551,
        "cert": "Chilean Acoustic Surveillance Representative"
    },
    {
        "id": 76,
        "name": "Electrodharma (Miguel Caro)",
        "category": "integrator",
        "country": "CL",
        "region": "us",
        "city": "Santiago, Chile",
        "address": "Av. Providencia 1208, Providencia, Santiago",
        "contact": "Miguel Caro",
        "phone": "+56 9 8765 4321",
        "email": "contacto@electrodharma.cl",
        "website": "www.electrodharma.cl",
        "lat": -33.428,
        "lng": -70.618,
        "cert": "Electronic & Audio Sensor Solutions Partner"
    },
    {
        "id": 77,
        "name": "Danaide S.A.",
        "category": "integrator",
        "country": "AR",
        "region": "us",
        "city": "Buenos Aires, Argentina",
        "address": "Av. del Libertador 6570, C1428 CABA, Buenos Aires",
        "contact": "Ing. Marcelo De Gennaro",
        "phone": "+54 11 5275 8000",
        "email": "info@danaide.com.ar",
        "website": "www.danaide.com.ar",
        "lat": -34.552,
        "lng": -58.452,
        "cert": "Smart Cities, Public Safety & Video Analytics Leader"
    },
    {
        "id": 78,
        "name": "IH Tech Labs S.A.",
        "category": "integrator",
        "country": "AR",
        "region": "us",
        "city": "Buenos Aires, Argentina",
        "address": "San Martín 674, C1004 AAN CABA, Buenos Aires",
        "contact": "Ignacio Hernandez",
        "phone": "+54 11 4312 8800",
        "email": "info@ihtechlabs.com",
        "website": "www.ihtechlabs.com",
        "lat": -34.6,
        "lng": -58.375,
        "cert": "IoT, Acoustic AI & Edge Computing Partner"
    },
    {
        "id": 79,
        "name": "VialSeg S.A.",
        "category": "integrator",
        "country": "AR",
        "region": "us",
        "city": "Córdoba & Buenos Aires, Argentina",
        "address": "Av. Colón 4500, X5003 Córdoba",
        "contact": "Dardo Lopez",
        "phone": "+54 351 480 9900",
        "email": "contacto@vialseg.com.ar",
        "website": "www.vialseg.com.ar",
        "lat": -31.398,
        "lng": -64.241,
        "cert": "Urban Mobility & Public Safety Systems Integrator"
    },
    {
        "id": 80,
        "name": "Abion Brasil Sistemas de Segurança",
        "category": "integrator",
        "country": "BR",
        "region": "us",
        "city": "São Paulo, Brazil",
        "address": "Av. Paulista 1079, Bela Vista, São Paulo - SP, 01311-200",
        "contact": "Roberto Silva",
        "phone": "+55 11 3280 4500",
        "email": "contato@abion.com.br",
        "website": "www.abion.com.br",
        "lat": -23.565,
        "lng": -46.652,
        "cert": "Brazilian Homeland & Perimeter Security Integrator"
    },
    {
        "id": 81,
        "name": "ALFTEC Indústria e Comércio Ltda",
        "category": "integrator",
        "country": "BR",
        "region": "us",
        "city": "Curitiba / Santa Catarina, Brazil",
        "address": "Rua Pasteur 463, Batel, Curitiba - PR, 80250-104",
        "contact": "Adriano Duarte",
        "phone": "+55 41 3090 8800",
        "email": "adriano.duarte@alftec.com.br",
        "website": "www.alftec.com.br",
        "lat": -25.441,
        "lng": -49.284,
        "cert": "Industrial Sound Detection & Telemetry Manufacturer"
    },
    {
        "id": 82,
        "name": "ISTC Corp (Colombia & Latin America HQ)",
        "category": "integrator",
        "country": "CO",
        "region": "us",
        "city": "Bogotá, Colombia & Miami, FL",
        "address": "Cra. 11 #86-60, Chico, Bogotá / 8400 NW 36th St, Miami FL",
        "contact": "Andres Rodriguez",
        "phone": "+57 1 744 3880",
        "email": "ventas@istccorp.com",
        "website": "www.istccorp.com",
        "lat": 4.673,
        "lng": -74.053,
        "cert": "Latin American Master Security Solutions Distributor"
    },
    {
        "id": 83,
        "name": "Markcom Global, S.A. de C.V.",
        "category": "integrator",
        "country": "MX",
        "region": "us",
        "city": "Mexico City, Mexico",
        "address": "Insurgentes Sur 1602, Crédito Constructor, Benito Juárez, 03940 CDMX",
        "contact": "Alvaro Garcia",
        "phone": "+52 55 5662 9900",
        "email": "alvaro.gs@markcom.com.mx",
        "website": "www.markcom.com.mx",
        "lat": 19.362,
        "lng": -99.182,
        "cert": "Public Safety & Video Surveillance Integrator"
    },
    {
        "id": 84,
        "name": "Seguridad Avanzada Mx",
        "category": "integrator",
        "country": "MX",
        "region": "us",
        "city": "Monterrey, N.L., Mexico",
        "address": "Av. Lázaro Cárdenas 2400, Valle Oriente, 66269 San Pedro Garza García, N.L.",
        "contact": "Juan Carlos Avila",
        "phone": "+52 81 8363 4400",
        "email": "contacto@seguridadavanzada.mx",
        "website": "www.seguridadavanzada.mx",
        "lat": 25.648,
        "lng": -100.315,
        "cert": "Commercial Perimeter & Tactical Audio Systems"
    },
    {
        "id": 85,
        "name": "Think Safe Tecnologia S.A.",
        "category": "integrator",
        "country": "MX",
        "region": "us",
        "city": "Guadalajara, Jalisco, Mexico",
        "address": "Av. Américas 1545, Providencia, 44630 Guadalajara, Jal.",
        "contact": "Rodrigo Morales",
        "phone": "+52 33 3640 1200",
        "email": "info@thinksafe.com.mx",
        "website": "www.thinksafe.com.mx",
        "lat": 20.702,
        "lng": -103.376,
        "cert": "Smart Campus & Urban Video Surveillance Partner"
    },
    {
        "id": 86,
        "name": "ACES Defense (Integrated Defense Systems Co.)",
        "category": "integrator",
        "country": "SA",
        "region": "me",
        "city": "Riyadh, Saudi Arabia",
        "address": "King Abdulaziz Road, Al Yasmin, Riyadh 13322",
        "contact": "Abdullah Nasser Alabduljabbar",
        "phone": "+966 11 419 8800",
        "email": "defense@aces.sa",
        "website": "www.aces.sa",
        "lat": 24.812,
        "lng": 46.645,
        "cert": "Saudi Defense, Border Security & Acoustic Protection"
    },
    {
        "id": 87,
        "name": "IoT Blue (Al-Khobar & Riyadh)",
        "category": "integrator",
        "country": "SA",
        "region": "me",
        "city": "Riyadh & Al-Khobar, Saudi Arabia",
        "address": "Prince Sultan Road, Al Rawabi, Al-Khobar 34421",
        "contact": "Smart Cities Team",
        "phone": "+966 13 898 5500",
        "email": "contact@iotblue.com",
        "website": "www.iotblue.com",
        "lat": 24.7136,
        "lng": 46.6753,
        "cert": "Smart City IoT Platform & Edge AI Integrator"
    },
    {
        "id": 88,
        "name": "Syncpoint Technologies LLC",
        "category": "integrator",
        "country": "SA",
        "region": "me",
        "city": "Riyadh, Saudi Arabia",
        "address": "Olaya Towers, Olaya St, Riyadh 12213",
        "contact": "Alaa Saleh",
        "phone": "+966 11 293 8811",
        "email": "alaa@sync-point.net",
        "website": "www.sync-point.net",
        "lat": 24.698,
        "lng": 46.685,
        "cert": "Enterprise Low Voltage & Mass Notification Integrator"
    },
    {
        "id": 89,
        "name": "Al Mansour Security Solutions",
        "category": "integrator",
        "country": "AE",
        "region": "me",
        "city": "Dubai, United Arab Emirates",
        "address": "Sheikh Zayed Rd, Business Bay, Dubai",
        "contact": "Tariq Mansour",
        "phone": "+971 4 368 8900",
        "email": "info@almansour-security.ae",
        "website": "www.almansour-security.ae",
        "lat": 25.186,
        "lng": 55.263,
        "cert": "GCC Homeland & High-Security Infrastructure"
    },
    {
        "id": 90,
        "name": "Shehabco Trading & Contracting Co.",
        "category": "integrator",
        "country": "EG",
        "region": "me",
        "city": "Cairo, Egypt",
        "address": "15 Mossadak St, Dokki, Giza, Cairo",
        "contact": "Eng. Tarek Shehab",
        "phone": "+20 2 3760 8800",
        "email": "info@shehabco.com",
        "website": "www.shehabco.com",
        "lat": 30.038,
        "lng": 31.206,
        "cert": "Egyptian Public Sector Security & CCTV Integrator"
    },
    {
        "id": 91,
        "name": "Aviotech (Pty) Ltd",
        "category": "integrator",
        "country": "ZA",
        "region": "me",
        "city": "Johannesburg, South Africa",
        "address": "Building 3, Maxwell Office Park, Magwa Cres, Midrand 2090",
        "contact": "Trevor Jacobs",
        "phone": "+27 11 805 1200",
        "email": "info@aviotech.co.za",
        "website": "www.aviotech.co.za",
        "lat": -26.012,
        "lng": 28.115,
        "cert": "Aviation, Perimeter & Acoustic Sensor Specialist"
    },
    {
        "id": 92,
        "name": "Secorriety South Africa",
        "category": "integrator",
        "country": "ZA",
        "region": "me",
        "city": "Cape Town & Pretoria, South Africa",
        "address": "Century City Dr, Century City, Cape Town 7441",
        "contact": "Kobus Van Der Merwe",
        "phone": "+27 21 552 8000",
        "email": "info@secorriety.co.za",
        "website": "www.secorriety.co.za",
        "lat": -33.892,
        "lng": 18.511,
        "cert": "Critical Asset Protection & Gunshot Alert Integrator"
    },
    {
        "id": 93,
        "name": "Tagged Technologies Ltd",
        "category": "integrator",
        "country": "NG",
        "region": "me",
        "city": "Lagos & Abuja, Nigeria",
        "address": "Plot 14, Victoria Arobieke St, Lekki Phase 1, Lagos",
        "contact": "Tunde Bakare",
        "phone": "+234 1 295 4400",
        "email": "info@taggedtech.ng",
        "website": "www.taggedtech.ng",
        "lat": 6.447,
        "lng": 3.472,
        "cert": "West Africa Surveillance & Homeland Security Integrator"
    },
    {
        "id": 94,
        "name": "Graphien Angola Lda",
        "category": "integrator",
        "country": "AO",
        "region": "me",
        "city": "Luanda, Angola",
        "address": "Rua Rainha Ginga, Edifício Vernon, Luanda",
        "contact": "Eng. Manuel Da Costa",
        "phone": "+244 222 390 100",
        "email": "geral@graphien.co.ao",
        "website": "www.graphien.co.ao",
        "lat": -8.815,
        "lng": 13.235,
        "cert": "Gunshot Detection & Public Safety Integrator (Luanda)"
    },
    {
        "id": 95,
        "name": "Startologic Technologies Pvt. Ltd.",
        "category": "integrator",
        "country": "IN",
        "region": "me",
        "city": "Thane / Mumbai, India",
        "address": "Ghodbunder Rd, Thane West, Thane, Maharashtra 400607",
        "contact": "Nilesh Sawant",
        "phone": "+91 98200 37144",
        "email": "connect@startologic.com",
        "website": "www.startologic.com",
        "lat": 19.2183,
        "lng": 72.9781,
        "cert": "Indian Smart City & Mass Transit Audio Analytics"
    },
    {
        "id": 96,
        "name": "Gold Lock Cyber Security",
        "category": "integrator",
        "country": "IL",
        "region": "me",
        "city": "Tel Aviv / Herzliya, Israel",
        "address": "Maskit St 8, Herzliya Pituach 4673308",
        "contact": "Noam Ronen",
        "phone": "+972 9 950 0110",
        "email": "info@gold-lock.com",
        "website": "www.gold-lock.com",
        "lat": 32.164,
        "lng": 34.808,
        "cert": "High-Security Communications & Threat Detection"
    },
    {
        "id": 97,
        "name": "AlgoVision Ltd",
        "category": "integrator",
        "country": "IL",
        "region": "me",
        "city": "Tel Aviv & Prague Office",
        "address": "Menachem Begin Rd 132, Tel Aviv-Yafo",
        "contact": "Michael Katz",
        "phone": "+972 3 609 8800",
        "email": "contact@algovision.ai",
        "website": "www.algovision.ai",
        "lat": 32.074,
        "lng": 34.791,
        "cert": "AI Edge Vision & Sound Fusion Partner"
    },
    {
        "id": 98,
        "name": "Novo Technologies S.A.",
        "category": "integrator",
        "country": "GR",
        "region": "es",
        "city": "Athens, Greece",
        "address": "Leof. Mesogeion 256, Cholargos 155 61, Athens",
        "contact": "Dimitris Nikolaou",
        "phone": "+30 210 654 8900",
        "email": "info@novo.gr",
        "website": "www.novo.gr",
        "lat": 38.002,
        "lng": 23.791,
        "cert": "Greek Smart Port & Perimeter Protection Integrator"
    },
    {
        "id": 99,
        "name": "Communication Progress Sh.p.k.",
        "category": "integrator",
        "country": "AL",
        "region": "es",
        "city": "Tirana, Albania",
        "address": "Rruga Dritan Hoxha, Ndërtesa 14, Tirana",
        "contact": "Gentian Likaj",
        "phone": "+355 4 227 4900",
        "email": "info@commprog.com",
        "website": "www.commprog.com",
        "lat": 41.332,
        "lng": 19.798,
        "cert": "Balkans Enterprise Telecom & Video Surveillance"
    },
    {
        "id": 100,
        "name": "Genet Güvenlik Sistemleri A.Ş.",
        "category": "integrator",
        "country": "TR",
        "region": "me",
        "city": "Istanbul, Turkey",
        "address": "Barbaros Blv. No:143, Balmumcu, Beşiktaş, 34349 İstanbul",
        "contact": "Murat Yilmaz",
        "phone": "+90 212 274 6600",
        "email": "info@genet.com.tr",
        "website": "www.genet.com.tr",
        "lat": 41.055,
        "lng": 29.008,
        "cert": "Turkish Smart Transportation & Campus Safety Partner"
    },
    {
        "id": 101,
        "name": "PV Services (1043524 Ontario Ltd)",
        "category": "integrator",
        "country": "CA",
        "region": "us",
        "city": "Vaughan (Toronto), ON, Canada",
        "address": "255 Regina Road, Vaughan, Ontario, L4L 8M3",
        "contact": "Paul Venier (President)",
        "phone": "+1 647 483 7009",
        "email": "admin@pvservices.ca",
        "website": "www.pvservices.ca",
        "lat": 43.7848,
        "lng": -79.5855,
        "cert": "Certified Canadian Security Systems Integrator"
    }
];

  const ITEMS_PER_PAGE = 9;
  const lang = getLocale() || 'en';
  const breadcrumbsData = {
    en: { home: 'Home', coop: 'Cooperation', current: 'Global Network & Distributors Map' },
    cs: { home: 'Domů', coop: 'Spolupráce', current: 'Globální síť distributorů a integrátorů' },
    de: { home: 'Startseite', coop: 'Kooperation', current: 'Globales Händlernetz & Integratoren' },
    es: { home: 'Inicio', coop: 'Cooperación', current: 'Red Global de Distribuidores e Integradores' },
    pt: { home: 'Início', coop: 'Cooperação', current: 'Rede Global de Distribuidores e Integradores' },
    it: { home: 'Home', coop: 'Cooperazione', current: 'Rete Globale di Distributori e Integratori' },
    ar: { home: 'الرئيسية', coop: 'التعاون', current: 'الشبكة العالمية وخريطة الموزعين' }
  };
  const bc = breadcrumbsData[lang] || breadcrumbsData.en;

  const dist_count = allPartnersList.filter(p => p.category === 'distributor').length;
  const int_count = allPartnersList.filter(p => p.category === 'integrator').length;
  let currentPage = 1;
  let currentCategoryFilter = 'all'; // 'all' | 'distributor' | 'integrator'
  let leafletMap = null;
  let markersGroup = null;

  container.innerHTML = `
    <!-- Header Hero -->
    <section class="sed-section" style="background: linear-gradient(165deg, var(--navy-dark) 0%, var(--blue-dark) 100%); color: #ffffff; padding: 4.5rem 0 3.5rem;">
      <div class="sed-container">
        <div style="display: flex; gap: 0.5rem; align-items: center; font-size: 0.85rem; color: #cbd5e1; margin-bottom: 1.5rem; flex-wrap: wrap;">
          <a href="#home" style="color: #ffffff; text-decoration: none;" data-route="home">${bc.home}</a> /
          <a href="#cooperation" style="color: #ffffff; text-decoration: none;" data-route="cooperation">${bc.coop}</a> /
          <span style="color: var(--blue-primary); font-weight: 700;">${bc.current}</span>
        </div>
        <div class="sed-section-header" style="max-width: 860px; text-align: left; margin: 0;">
          <div class="sed-eyebrow" style="background: rgba(255,255,255,0.1); color: var(--blue-primary); border-color: rgba(255,255,255,0.2);">${t('mapPage.eyebrow') || 'GLOBAL NETWORK & PARTNERS'}</div>
          <h1 class="sed-page-hero-title" style="color: #ffffff;">${t('mapPage.title')}</h1>
          <p style="font-size: 1.15rem; color: #e2e8f0; line-height: 1.65; margin-bottom: 0;">
            ${t('mapPage.subtitle')}
          </p>
        </div>
      </div>
    </section>

    <!-- Map & Partners Directory Section -->
    <section class="sed-section" style="background-color: #ffffff; padding: 3rem 0 5rem;">
      <div class="sed-container">
        <!-- Category & Region Controls Bar -->
        <div class="sed-card" style="padding: 1.5rem; margin-bottom: 1.5rem; background: #ffffff; border: 1px solid var(--slate-line);">
          <div style="display: flex; flex-direction: column; gap: 1.25rem;">
            
            <!-- Type Filters Row -->
            <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 1rem;">
              <div style="font-size: 0.95rem; font-weight: 800; color: var(--navy-dark);">${t('mapPage.filterType') || 'Filter Partner Type:'}</div>
              <div style="display: flex; gap: 0.75rem; flex-wrap: wrap;">
                <button class="sed-btn sed-btn-primary" id="btn-filter-all">${t('mapPage.allPartners')} (${allPartnersList.length})</button>
                <button class="sed-btn sed-btn-outline" id="btn-filter-dist" style="color: var(--blue-primary); border-color: var(--blue-primary);">
                  🔷 ${t('mapPage.distributorsOnly')} (${dist_count})
                </button>
                <button class="sed-btn sed-btn-outline" id="btn-filter-int" style="color: #d97706; border-color: #f59e0b;">
                  🟧 ${t('mapPage.integratorsOnly')} (${int_count})
                </button>
              </div>
            </div>

            <!-- Region Quick Zoom Buttons Row -->
            <div style="display: flex; align-items: center; gap: 0.75rem; flex-wrap: wrap; border-top: 1px dashed var(--slate-line); padding-top: 1rem;">
              <span style="font-size: 0.88rem; font-weight: 800; color: var(--navy-dark); min-width: 140px;">${t('mapPage.regionalZoom') || 'Regional Zoom:'}</span>
              <div style="display: flex; gap: 0.5rem; flex-wrap: wrap; flex: 1;">
                <button class="sed-btn sed-btn-outline" style="padding: 0.4rem 0.85rem; font-size: 0.85rem;" id="zoom-uk">🇬🇧 ${t('mapPage.zoomRegions.uk') || 'UK & Ireland'}</button>
                <button class="sed-btn sed-btn-outline" style="padding: 0.4rem 0.85rem; font-size: 0.85rem;" id="zoom-cz">🇨🇿 ${t('mapPage.zoomRegions.cz') || 'Czechia & Central Europe'}</button>
                <button class="sed-btn sed-btn-outline" style="padding: 0.4rem 0.85rem; font-size: 0.85rem;" id="zoom-de">🇩🇪 ${t('mapPage.zoomRegions.de') || 'DACH (Germany / Austria / CH)'}</button>
                <button class="sed-btn sed-btn-outline" style="padding: 0.4rem 0.85rem; font-size: 0.85rem;" id="zoom-es">🇪🇸 ${t('mapPage.zoomRegions.es') || 'Spain & Southern Europe'}</button>
                <button class="sed-btn sed-btn-outline" style="padding: 0.4rem 0.85rem; font-size: 0.85rem;" id="zoom-nordics">🇳🇴 ${t('mapPage.zoomRegions.nordics') || 'Nordics & Baltics'}</button>
                <button class="sed-btn sed-btn-outline" style="padding: 0.4rem 0.85rem; font-size: 0.85rem;" id="zoom-us">🇺🇸 ${t('mapPage.zoomRegions.us') || 'Americas (USA / Canada / LatAm)'}</button>
                <button class="sed-btn sed-btn-outline" style="padding: 0.4rem 0.85rem; font-size: 0.85rem;" id="zoom-me">🌍 ${t('mapPage.zoomRegions.me') || 'Middle East, Africa & Asia'}</button>
                <button class="sed-btn sed-btn-outline" style="padding: 0.4rem 0.85rem; font-size: 0.85rem;" id="zoom-world">🌐 ${t('mapPage.zoomRegions.world') || 'Global Overview'}</button>
              </div>
            </div>

          </div>
        </div>

        <!-- Interactive Leaflet Map Canvas Box -->
        <div class="sed-card" style="padding: 0; overflow: hidden; margin-bottom: 2.5rem; border: 2px solid var(--navy-dark); border-radius: var(--radius-unified); box-shadow: 0 15px 40px rgba(0,0,0,0.12);">
          
          <!-- Map Status Bar -->
          <div style="background-color: #f8fafc; color: var(--navy-dark); border-bottom: 1px solid var(--slate-line); padding: 0.85rem 1.5rem; display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 0.5rem;">
            <div style="display: flex; align-items: center; gap: 12px;">
              <span style="font-size: 0.95rem; font-weight: 800; color: var(--navy-dark);" id="map-status-title">📍 ${t('mapPage.mapTitle') || 'Interactive Zoomable Partner Map'}</span>
              <span style="font-size: 0.8rem; color: var(--text-muted);">(${t('mapPage.mapHint') || 'Scroll or click + / - to zoom into street level'})</span>
            </div>
            <div style="display: flex; gap: 14px; font-size: 0.82rem; font-weight: 800;">
              <span style="color: #0284c7;">🔷 ${t('mapPage.legendDistributor') || 'Blue Pin = Master Distributor'}</span>
              <span style="color: #d97706;">🟧 ${t('mapPage.legendIntegrator') || 'Amber Pin = System Integrator'}</span>
            </div>
          </div>

          <!-- Leaflet DOM Mount Element -->
          <div id="sed-leaflet-map-element" style="width: 100%; height: 560px; background-color: #f8fafc; position: relative;">
            <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: var(--navy-dark); font-weight: 700; font-size: 1rem;" id="map-loading-indicator">
              ${t('mapPage.loadingMap') || 'Loading High-Contrast Street Tiles & Pins...'}
            </div>
          </div>
        </div>

        <!-- Search & Directory Header -->
        <div id="sed-directory-heading-wrap" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1.5rem; flex-wrap: wrap; gap: 1rem;">
          <div>
            <h2 style="font-family: var(--font-heading); font-size: 1.75rem; font-weight: 800; color: var(--navy-dark); margin: 0;">
              ${t('mapPage.directoryTitle') || 'Directory Listing'}
            </h2>
            <div style="font-size: 0.85rem; color: var(--text-muted); margin-top: 0.25rem;" id="partner-count-indicator">
              Showing 9 of ${allPartnersList.length} partners (Page 1)
            </div>
          </div>
          <input type="text" id="partner-search-input" placeholder="${t('mapPage.searchPlaceholder') || '🔍 Search company name, city, email or country...'}" style="width: 340px; max-width: 100%; padding: 0.65rem 1rem; border: 1px solid var(--slate-line); border-radius: var(--radius-unified); font-size: 0.9rem; outline: none;">
        </div>

        <!-- Partner Cards Grid Container (STRICT 9 PER PAGE LIMIT) -->
        <div id="sed-partners-cards-grid" class="sed-grid-3" style="width: 100%; box-sizing: border-box;">
          <!-- Dynamically Injected Cards (Max 9) -->
        </div>

        <!-- Pagination Controls Bar -->
        <div id="sed-directory-pagination" style="display: flex; justify-content: center; align-items: center; gap: 0.5rem; margin-top: 2.5rem; flex-wrap: wrap;">
          <!-- Pagination Buttons Injected Here -->
        </div>

        <!-- Become a Partner CTA Box -->
        <div class="sed-card" style="margin-top: 3.5rem; background: linear-gradient(135deg, var(--blue-primary), var(--blue-dark)); color: #ffffff; padding: 3rem; text-align: center;">
          <h2 style="font-family: var(--font-heading); font-size: 2rem; font-weight: 800; margin-bottom: 1rem;">
            ${t('mapPage.ctaTitle') || 'Become an Authorized SED Distributor or System Integrator'}
          </h2>
          <p style="font-size: 1.05rem; opacity: 0.95; max-width: 680px; margin: 0 auto 2rem; line-height: 1.65;">
            ${t('mapPage.ctaDesc') || "Expand your security portfolio with the world's leading edge AI acoustic detection technology. Native edge plugins across all supported platforms (Axis, Hanwha, Hikvision...), VMS integrations, zero-cost NFR (not for resell) SW licenses for testing and demonstrations, and partner marketing support provided."}
          </p>
          <a href="#contact" class="sed-btn sed-btn-hero" style="background-color: #ffffff; color: var(--navy-dark); font-weight: 800;" data-route="contact">${t('mapPage.ctaButton') || 'Apply for Partner Program →'}</a>
        </div>
      </div>
    </section>
  `;

  // Function to render Directory Cards with STRICT 9-ITEM PAGINATION
  function renderCards(filterType = 'all', searchQuery = '') {
    const gridEl = container.querySelector('#sed-partners-cards-grid');
    const paginationEl = container.querySelector('#sed-directory-pagination');
    const countIndicator = container.querySelector('#partner-count-indicator');
    if (!gridEl) return;

    let filtered = allPartnersList;
    if (filterType === 'distributor') {
      filtered = filtered.filter(p => p.category === 'distributor');
    } else if (filterType === 'integrator') {
      filtered = filtered.filter(p => p.category === 'integrator');
    }

    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      filtered = filtered.filter(p => 
        p.name.toLowerCase().includes(q) ||
        p.city.toLowerCase().includes(q) ||
        p.address.toLowerCase().includes(q) ||
        p.contact.toLowerCase().includes(q) ||
        p.email.toLowerCase().includes(q) ||
        p.country.toLowerCase().includes(q)
      );
    }

    const totalItems = filtered.length;
    const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE) || 1;

    // Reset to page 1 if current page exceeds bounds
    if (currentPage > totalPages) currentPage = 1;

    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const paginatedItems = filtered.slice(startIndex, startIndex + ITEMS_PER_PAGE);

    if (countIndicator) {
      countIndicator.textContent = `Showing ${paginatedItems.length} of ${totalItems} partners (Page ${currentPage} of ${totalPages})`;
    }

    if (paginatedItems.length === 0) {
      gridEl.innerHTML = `
        <div style="grid-column: 1 / -1; text-align: center; padding: 3rem 1rem; background: #f8fafc; border-radius: var(--radius-unified); border: 1px dashed var(--slate-line);">
          <div style="font-size: 2rem; margin-bottom: 0.5rem;">🔍</div>
          <div style="font-weight: 700; font-size: 1.1rem; color: var(--navy-dark); margin-bottom: 0.25rem;">${t('mapPage.noMatches') || 'No Partners Found'}</div>
          <div style="font-size: 0.9rem; color: var(--text-muted);">${t('mapPage.noMatchesHint') || 'Try clearing your search query or selecting a different partner filter.'}</div>
        </div>
      `;
    } else {
      gridEl.innerHTML = paginatedItems.map(partner => {
        const isDistributor = partner.category === 'distributor';
        const badgeColor = isDistributor ? 'var(--blue-primary)' : '#d97706';
        const badgeBg = isDistributor ? 'var(--blue-ultra-light)' : '#fef3c7';
        const badgeText = isDistributor ? '🔷 Master Distributor' : '🟧 System Integrator / Partner';

        return `
          <div class="sed-card" style="display: flex; flex-direction: column; justify-content: space-between; border-radius: var(--radius-unified); border: 1px solid var(--slate-line); padding: 1.5rem; transition: transform 0.2s, box-shadow 0.2s; position: relative;">
            <div>
              <!-- Badge -->
              <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 0.75rem; gap: 8px;">
                <span style="background: ${badgeBg}; color: ${badgeColor}; font-weight: 800; font-size: 0.75rem; padding: 4px 8px; border-radius: 4px; text-transform: uppercase;">
                  ${badgeText}
                </span>
                <span style="font-size: 0.75rem; font-weight: 800; color: var(--text-light); background: #f1f5f9; padding: 2px 6px; border-radius: 4px;">
                  ${partner.country}
                </span>
              </div>

              <!-- Title -->
              <h3 class="sed-card-title">
                ${partner.name}
              </h3>

              <!-- Certification -->
              <div style="font-size: 0.8rem; font-weight: 700; color: var(--blue-primary); margin-bottom: 0.85rem;">
                ✓ ${partner.cert}
              </div>

              <!-- Address & Details -->
              <div style="font-size: 0.86rem; color: var(--text-dark); line-height: 1.6; margin-bottom: 1rem;">
                <div style="margin-bottom: 3px;">📍 <strong>${partner.city}</strong></div>
                <div style="color: var(--text-muted); font-size: 0.82rem; margin-bottom: 6px;">${partner.address}</div>
                ${partner.contact ? `<div>👤 ${partner.contact}</div>` : ''}
                ${partner.phone ? `<div>📞 ${partner.phone}</div>` : ''}
                ${partner.email ? `<div>✉️ <span class="sed-obf-email" data-u="${btoa(partner.email.split('@')[0])}" data-d="${btoa(partner.email.split('@')[1])}" data-t="${btoa(partner.email)}" style="color: var(--blue-primary); text-decoration: underline;"><span class="sed-obf-fallback">${partner.email.replace('@', ' [at] ')}</span></span></div>` : ''}
                ${partner.website ? `<div>🌐 <a href="https://${partner.website}" target="_blank" rel="noopener noreferrer" style="color: var(--blue-primary); text-decoration: underline;">${partner.website}</a></div>` : ''}
              </div>
            </div>

            <!-- Card Bottom Action -->
            <div style="border-top: 1px solid var(--slate-line); padding-top: 0.85rem; margin-top: 0.5rem; display: flex; justify-content: space-between; align-items: center;">
              <button class="sed-btn sed-btn-outline btn-locate-partner" data-lat="${partner.lat}" data-lng="${partner.lng}" data-name="${partner.name}" style="padding: 0.35rem 0.75rem; font-size: 0.8rem; width: 100%;">
                📍 ${t('mapPage.zoomOnMap') || 'Zoom on Map'}
              </button>
            </div>
          </div>
        `;
      }).join('');
    }

    // Render Pagination Controls
    if (paginationEl) {
      if (totalPages <= 1) {
        paginationEl.innerHTML = '';
      } else {
        let pagHtml = `
          <div style="display: flex; align-items: center; justify-content: center; gap: 0.4rem; flex-wrap: wrap; width: 100%;">
            <!-- First Page Button -->
            <button class="pag-btn" data-page="1" ${currentPage === 1 ? 'disabled style="opacity: 0.45; cursor: not-allowed;"' : ''}>
              « First
            </button>
            
            <!-- Previous Page Button -->
            <button class="pag-btn" data-page="${currentPage - 1}" ${currentPage === 1 ? 'disabled style="opacity: 0.45; cursor: not-allowed;"' : ''}>
              ‹ Prev
            </button>
        `;

        for (let p = 1; p <= totalPages; p++) {
          const isActive = p === currentPage;
          pagHtml += `
            <button class="pag-btn ${isActive ? 'active sed-btn-primary' : ''}" data-page="${p}">
              ${p}
            </button>
          `;
        }

        pagHtml += `
            <!-- Next Page Button -->
            <button class="pag-btn" data-page="${currentPage + 1}" ${currentPage === totalPages ? 'disabled style="opacity: 0.45; cursor: not-allowed;"' : ''}>
              Next ›
            </button>

            <!-- Last Page Button -->
            <button class="pag-btn" data-page="${totalPages}" ${currentPage === totalPages ? 'disabled style="opacity: 0.45; cursor: not-allowed;"' : ''}>
              Last »
            </button>

            <!-- Quick Page Jump Selector -->
            <div style="display: inline-flex; align-items: center; gap: 6px; margin-left: 12px; font-size: 0.88rem; color: var(--text-dark); font-weight: 600;">
              <span>Jump to:</span>
              <select id="sed-quick-page-select" style="padding: 0.35rem 0.65rem; border: 1.5px solid var(--slate-line); border-radius: 8px; font-weight: 700; background: #ffffff; color: var(--navy-dark); cursor: pointer; outline: none;">
                ${Array.from({ length: totalPages }, (_, i) => i + 1).map(p => `
                  <option value="${p}" ${p === currentPage ? 'selected' : ''}>Page ${p} of ${totalPages}</option>
                `).join('')}
              </select>
            </div>
          </div>
        `;
        paginationEl.innerHTML = pagHtml;

        paginationEl.querySelectorAll('.pag-btn').forEach(btn => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            if (btn.hasAttribute('disabled')) return;
            const pageTarget = parseInt(btn.getAttribute('data-page'), 10);
            if (!isNaN(pageTarget) && pageTarget >= 1 && pageTarget <= totalPages && pageTarget !== currentPage) {
              currentPage = pageTarget;
              renderCards(currentCategoryFilter, container.querySelector('#partner-search-input')?.value || '');
              const headingEl = container.querySelector('#sed-directory-heading-wrap');
              if (headingEl) {
                const topOffset = headingEl.getBoundingClientRect().top + window.pageYOffset - 90;
                window.scrollTo({ top: topOffset, behavior: 'smooth' });
              }
            }
          });
        });

        const quickSelect = paginationEl.querySelector('#sed-quick-page-select');
        if (quickSelect) {
          quickSelect.addEventListener('change', (e) => {
            const pageTarget = parseInt(e.target.value, 10);
            if (!isNaN(pageTarget) && pageTarget >= 1 && pageTarget <= totalPages && pageTarget !== currentPage) {
              currentPage = pageTarget;
              renderCards(currentCategoryFilter, container.querySelector('#partner-search-input')?.value || '');
              const headingEl = container.querySelector('#sed-directory-heading-wrap');
              if (headingEl) {
                const topOffset = headingEl.getBoundingClientRect().top + window.pageYOffset - 90;
                window.scrollTo({ top: topOffset, behavior: 'smooth' });
              }
            }
          });
        }
      }
    }

    // Attach Locate on Map click handlers
    gridEl.querySelectorAll('.btn-locate-partner').forEach(btn => {
      btn.addEventListener('click', () => {
        const lat = parseFloat(btn.getAttribute('data-lat'));
        const lng = parseFloat(btn.getAttribute('data-lng'));
        const name = btn.getAttribute('data-name');
        if (leafletMap && !isNaN(lat) && !isNaN(lng)) {
          leafletMap.flyTo([lat, lng], 13, { duration: 1.5 });
          container.querySelector('#sed-leaflet-map-element')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    });
  }

  // Filter Buttons
  const btnAll = container.querySelector('#btn-filter-all');
  const btnDist = container.querySelector('#btn-filter-dist');
  const btnInt = container.querySelector('#btn-filter-int');
  const searchInput = container.querySelector('#partner-search-input');

  function updateFilterButtons(activeFilter) {
    currentCategoryFilter = activeFilter;
    currentPage = 1;
    [btnAll, btnDist, btnInt].forEach(b => {
      b.classList.remove('sed-btn-primary');
      b.classList.add('sed-btn-outline');
    });
    if (activeFilter === 'all') {
      btnAll.classList.add('sed-btn-primary');
      btnAll.classList.remove('sed-btn-outline');
    } else if (activeFilter === 'distributor') {
      btnDist.classList.add('sed-btn-primary');
      btnDist.classList.remove('sed-btn-outline');
    } else if (activeFilter === 'integrator') {
      btnInt.classList.add('sed-btn-primary');
      btnInt.classList.remove('sed-btn-outline');
    }
    renderCards(currentCategoryFilter, searchInput?.value || '');
    updateMapPins(currentCategoryFilter);
  }

  btnAll?.addEventListener('click', () => updateFilterButtons('all'));
  btnDist?.addEventListener('click', () => updateFilterButtons('distributor'));
  btnInt?.addEventListener('click', () => updateFilterButtons('integrator'));

  searchInput?.addEventListener('input', (e) => {
    currentPage = 1;
    renderCards(currentCategoryFilter, e.target.value);
  });

  // Initial Card Render
  renderCards('all', '');

  // Leaflet Map Initialization
  function initMap() {
    const mapElement = container.querySelector('#sed-leaflet-map-element');
    const loadingIndicator = container.querySelector('#map-loading-indicator');
    if (!mapElement) return;

    if (loadingIndicator) loadingIndicator.style.display = 'none';

    // Prevent duplicate map initialization
    if (leafletMap) {
      try {
        leafletMap.remove();
      } catch (e) {}
      leafletMap = null;
    }

    try {
      leafletMap = L.map(mapElement, {
        center: [38.0, 15.0],
        zoom: 3,
        minZoom: 2,
        maxZoom: 18,
        maxBounds: [[-85, -180], [85, 180]],
        maxBoundsViscosity: 1.0,
        worldCopyJump: false,
        scrollWheelZoom: true,
        zoomControl: true
      });

      // 100% Free Esri World Street Map (Detailed street-level tiles without API key requirement)
      const tileUrl = 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}';
      L.tileLayer(tileUrl, {
        attribution: 'Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, TomTom',
        maxZoom: 18,
        noWrap: true,
        bounds: [[-85, -180], [85, 180]],
        crossOrigin: true
      }).addTo(leafletMap);

      markersGroup = L.layerGroup().addTo(leafletMap);

      updateMapPins('all');

      // Multiple invalidateSize ticks to ensure full container measurement across all viewports
      setTimeout(() => { if (leafletMap) leafletMap.invalidateSize(); }, 50);
      setTimeout(() => { if (leafletMap) leafletMap.invalidateSize(); }, 200);
      setTimeout(() => { if (leafletMap) leafletMap.invalidateSize(); }, 600);
      setTimeout(() => { if (leafletMap) leafletMap.invalidateSize(); }, 1200);

      // Observe map element resizing
      if (window.ResizeObserver) {
        const ro = new ResizeObserver(() => {
          if (leafletMap) {
            leafletMap.invalidateSize();
          }
        });
        ro.observe(mapElement);
        container._mapResizeObserver = ro;
      }

      // Regional Zoom Event Listeners
      const zoomHandlers = {
        '#zoom-uk': { center: [54.5, -2.5], zoom: 6 },
        '#zoom-cz': { center: [49.8, 15.5], zoom: 7 },
        '#zoom-de': { center: [50.5, 10.5], zoom: 6 },
        '#zoom-es': { center: [40.2, -3.7], zoom: 6 },
        '#zoom-nordics': { center: [58.5, 17.5], zoom: 5 },
        '#zoom-us': { center: [38.0, -97.0], zoom: 4 },
        '#zoom-me': { center: [25.0, 45.0], zoom: 4 },
        '#zoom-world': { center: [30.0, 10.0], zoom: 2 }
      };

      Object.entries(zoomHandlers).forEach(([btnId, cfg]) => {
        container.querySelector(btnId)?.addEventListener('click', () => {
          if (leafletMap) {
            leafletMap.flyTo(cfg.center, cfg.zoom, { duration: 1.2 });
          }
        });
      });
    } catch (err) {
      console.error('Leaflet map initialization error:', err);
    }
  }

  function updateMapPins(filterType) {
    if (!markersGroup || typeof L === 'undefined') return;
    markersGroup.clearLayers();

    let items = allPartnersList;
    if (filterType === 'distributor') {
      items = items.filter(p => p.category === 'distributor');
    } else if (filterType === 'integrator') {
      items = items.filter(p => p.category === 'integrator');
    }

    items.forEach(partner => {
      const isDist = partner.category === 'distributor';
      const pinColor = isDist ? '#0284c7' : '#d97706';

      const customIcon = L.divIcon({
        className: 'custom-sed-pin',
        html: `<div style="background-color: ${pinColor}; color: #ffffff; width: 28px; height: 28px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 13px; font-weight: 800; border: 2px solid #ffffff; box-shadow: 0 4px 10px rgba(0,0,0,0.35);">
                 ${isDist ? '🔷' : '🟧'}
               </div>`,
        iconSize: [28, 28],
        iconAnchor: [14, 14],
        popupAnchor: [0, -14]
      });

      const popupContent = `
        <div style="font-family: var(--font-body); padding: 4px; max-width: 240px;">
          <div style="font-size: 0.72rem; font-weight: 800; text-transform: uppercase; color: ${pinColor}; margin-bottom: 2px;">
            ${isDist ? 'Master Distributor' : 'System Integrator'} (${partner.country})
          </div>
          <strong style="font-size: 0.95rem; color: var(--navy-dark); display: block; margin-bottom: 4px;">
            ${partner.name}
          </strong>
          <div style="font-size: 0.8rem; color: var(--text-dark); margin-bottom: 6px;">
            📍 ${partner.city}<br>
            ${partner.contact ? `👤 ${partner.contact}<br>` : ''}
            ${partner.email ? `✉️ <span class="sed-obf-email" data-u="${btoa(partner.email.split('@')[0])}" data-d="${btoa(partner.email.split('@')[1])}" data-t="${btoa(partner.email)}" style="color: var(--blue-primary);"><span class="sed-obf-fallback">${partner.email.replace('@', ' [at] ')}</span></span>` : ''}
          </div>
          <div style="font-size: 0.75rem; font-weight: 700; color: var(--blue-primary);">
            ✓ ${partner.cert}
          </div>
        </div>
      `;

      const marker = L.marker([partner.lat, partner.lng], { icon: customIcon }).bindPopup(popupContent);
      markersGroup.addLayer(marker);
    });
  }

  // Initialize Map after DOM attach
  setTimeout(initMap, 50);

  // Link navigation handlers
  container.querySelectorAll('[data-route]').forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      if (onNavigate) onNavigate(link.getAttribute('data-route'));
    });
  });

  return container;
}
